// extracted by mini-css-extract-plugin
export default {"cta":"bE-z","disabled":"cE-z"};